import PersonSerializer from '@linc-technologies/linced-common/serializers/person';

export default class Person extends PersonSerializer {
  modelNameFromPayloadKey(key) {
    if (key.substr(0, 9) === 'enrolment') {
      return super.modelNameFromPayloadKey('people/' + key);
    }
    return super.modelNameFromPayloadKey(...arguments);
  }
}
